import { fontSize_15, fontSize_20, fontSize_32 } from "../../../shared/styleconfig"
import graph from '../../../assets/images/graph.png'
import { LinearProgress, Skeleton } from "@mui/material"
import { getCommaSeperated } from "../../../util/functions"
import { useEffect, useState } from "react"
import axios from "axios"
import { TAAPI_API_KEY, VINTAGE_API } from "../../../shared/taapiConfig"
import { ChartContainer } from '@mui/x-charts';
import { LinePlot, MarkPlot } from '@mui/x-charts/LineChart';
import '../../Home/style.css'

const Stock = ({stock, i, myStocks}) => {
    const [stockData, setStockData] = useState(null);
    const [lineColor, setLineColor] = useState('red');
    const xLabels = [
    'Page A',
    'Page B',
    'Page C',
    'Page D',
    'Page E',
    'Page F',
    'Page G',
    ];

    useEffect(() => {
        const fetchStockData = async () => {
          try {
            const response = await axios.get(
              `https://api.taapi.io/candles?secret=${TAAPI_API_KEY}&type=stocks&symbol=${stock}&interval=1d`
            );
            const stockDates = response?.data?.reverse()?.map((item) => item?.close);
            stockDates.length = 7;
            if(myStocks[stock]?.avgBuyprice > stockDates[0] ){
                setLineColor('green')
            }
            setStockData(stockDates)
          } catch (error) {
            console.error('Error fetching stock data:', error);
          }
        };
        fetchStockData();
      }, []);

    return <div className="flex flex-col">
    {
        i ===0 ? 
        <div className="flex flex-row items-center mb-[15px] flex-wrap">
            <div className="flex flex-col flex-[0.4] text-[#FAFAFB] font-bold">Stock </div>
            <div className={`xs:text-xs sm:text-sm  md:text-[15px] text-[#FAFAFB] font-[100] pr-[15px] flex-[0.2] font-bold`}>Current Value</div>
            <div className={`xs:text-xs sm:text-sm  md:text-[15px] text-[#FAFAFB] font-[100] pr-[15px] flex-[0.2] font-bold`}>Purchased Value</div>
            <div className={`flex-[0.2]`}> &nbsp;</div>
        </div>
        :""
    }
        
        <div className="flex flex-row items-center mt-[15px] flex-wrap" key={i} >
            
        <div className="flex flex-col flex-[0.4]">
            <p className={`xs:text-sm sm:text-sm  md:text-[20px] text-[#FAFAFB]`}>{stock}</p>
            <span className={`xs:text-[10px] sm:text-[12px]  md:text-[15px] text-[#FAFAFB50] uppercase`}>{myStocks[stock]?.protfolioQty} Shares</span>
        </div>

        <div className={`xs:text-xs sm:text-sm  md:text-[20px] text-[#FAFAFB] font-[100] pr-[15px] flex-[0.2] text-left `} >{getCommaSeperated(parseFloat(myStocks[stock]?.currentpotfolioAmt).toFixed(2))}
        </div>

        <div className={`xs:text-xs sm:text-sm  md:text-[20px] text-[#FAFAFB] font-[100] pr-[15px] flex-[0.2] text-left`} >{getCommaSeperated(parseFloat(myStocks[stock]?.protfolioAmt).toFixed(2))}</div>

        <div className="flex-[0.2] max-w-[152px] relative stock-chart" >
        {
            stockData !== null && stockData?.length ?
            <ChartContainer
            width={200}
            height={120}
            series={[{ type: 'line', data: stockData }]}
            xAxis={[{ scaleType: 'point', data: xLabels }]}
            sx={{
                '.MuiLineElement-root': {
                stroke: lineColor,
                strokeWidth: 2,
                position: 'absolute',
                top: -55
                },
            }}
            margin={0}
            // viewBox={}
            disableAxisListener
            >
            <LinePlot />
            {/* <MarkPlot /> */}
            </ChartContainer>
            : <LinearProgress />
        }
        </div>
    
        </div>
    </div>
}

export const StockList = ({
    title,
    myStocks,
    myStocksLoader
}) => {
    const getStocks = () => {
        if(Object?.keys(myStocks)?.length > 0) {
            return [...Object?.keys(myStocks)]?.map((stock, i) => {
               return <Stock stock={stock} i={i} myStocks={myStocks} />
            })
        }
        else {
            return <div className="text-white flex flex-1 items-center justify-center h-full"></div>
        }
    }


    return (
        <div className={`flex bg-[#001639] rounded-[20px] flex-col lg:h-full xs:h-[unset] lg:flex-1 xs:flex-[unset]  overflow-x-auto no-scrollbar h-[557px]`}>
            <label className={`${fontSize_32} text-[#FFFFFF] font-bold md:px-[30px] xs:px-[15px] py-7`}>
                {title}
            </label>

            <div className="flex flex-col lg:flex-1 xs:flex-[unset] md:px-[30px] xs:px-[15px] md:gap-[40px] xs:gap-[20px] xs:h-[400px] lg:h-[auto] overflow-x-auto no-scrollbar">
                {myStocksLoader ? (
                    <div className="text-white flex flex-1 items-center justify-center">Loading Stocks. Please wait...</div>
                ) : (
                    Object?.keys(myStocks)?.length ? <div>
                  
                    {getStocks()}
                </div> : <div className="text-white text-center flex flex-col justify-center h-[80%] text-[20px] " >
                            No Stocks Found
                        </div>
                )}
            </div>
        </div>
    )
}